import { forwardRef } from "react";
import { Typography } from "antd";
import classNames from "classnames";
import type { TitleProps } from "antd/lib/typography/Title";
import type { TextLineHeight, TextSize, TextType, TextWeight } from "../types";
import styles from "./styles.module.scss";

const { Title } = Typography;

type Props = {
  titleType?: TextType;
  weight?: TextWeight;
  size?: TextSize;
  lineHeight?: TextLineHeight;
} & TitleProps;

export const AppTitle = forwardRef<HTMLElement, Props>(
  ({ className, titleType, weight, size, lineHeight, ...props }, ref) => {
    return (
      <Title
        ref={ref}
        className={classNames(
          [
            styles.title,
            styles[`type-${titleType}`],
            styles[`size-${size}`],
            styles[`weight-${weight}`],
            styles[`line-height-${lineHeight}`],
          ],
          className,
        )}
        {...props}
      />
    );
  },
);
